export default __webpack_public_path__ + "static/media/Animals03.98157e0e.jpg";